import { searchBridgePayers } from "@/api/generated";
import {
  type AutocompleteOption,
  AutocompleteSelect,
  Input,
} from "@/components";
import { type CarrierValue, EMPTY_CARRIER } from "@/forms/carrierSchema";

const query = async (
  search: string,
): Promise<AutocompleteOption<boolean>[]> => {
  const payers = await searchBridgePayers({ query: search, limit: 30 });
  return payers.map((payer) => ({
    value: payer.id,
    label: payer.name,
    text: payer.name,
    data: payer.member_id,
  }));
};

export type CarrierSearchFieldProps = {
  value: CarrierValue;
  onChange: (value: CarrierValue) => void;
  onBlur?: () => void;
  errorText?: string;
  label?: string;
  placeholder?: string;
  testID?: string;
  rootProps?: React.ComponentProps<typeof Input.Controlled>["rootProps"];
};

export function CarrierSearchField({
  value,
  onChange,
  onBlur,
  errorText,
  label = "Insurance carrier",
  placeholder = "Search by carrier name...",
  testID,
  rootProps,
}: CarrierSearchFieldProps) {
  return (
    <AutocompleteSelect
      value={value.bridgePayerId}
      displayText={value.carrierName}
      query={query}
      onSelect={(option) =>
        onChange({
          carrierName: option.text ?? option.label,
          bridgePayerId: option.value,
          requiresMemberId: option.data ?? true,
        })
      }
      onClear={() => onChange(EMPTY_CARRIER)}
      onBlur={onBlur}
      dataTrackingId="bridge-payer-carrier"
      errorText={errorText}
      emptyText="No matching insurance carriers. Try a different search."
      label={label}
      placeholder={placeholder}
      testID={testID}
      rootProps={rootProps}
    />
  );
}
